import { Col, Row } from "react-bootstrap";
import image1 from "assets/images/cs/client-charter/1.png";

import "styles/page.css";
import "./ClientCharter.css";

import parse from "html-react-parser";
import { clientCharterItems } from "constants/customer-service";
import { PrimaryButton } from "components/buttons";
import { handleOpenPdf } from "utils";
import { CUSTOMER_CLIENT_CHARTER } from "constants/pdf";

function ClientCharter() {
  return (
    <>
      <div className="container page">
        <h1 className="page-title">Client Charter</h1>

        <p className="page-subtitle">
          Guided by our values, we believe in providing Shariah-compliant
          banking products and services based on fair and honest Islamic
          principles that derive win-win lasting partnerships via our
          tailor-made solutions and customer care that respect and benefit your
          banking needs.
          <br />
          <br />
          With this in mind, we have crafted and practiced the key commitments
          that lie at the heart of our Client Charter in our dealings with our
          customers
        </p>
      </div>

      <div className="content-card">
        <div className="container">
          <Row>
            <Col md={3} xs={12}>
              <div className="d-flex justify-content-center">
                <img alt="security-img" src={image1} />
              </div>
            </Col>
            <Col md={9} xs={12}>
              <div className="label">
                <p>Security</p>
              </div>
              <h1>
                Safety and security of operations in our financial services
                provision is of utmost importance
              </h1>
              <p>
                We place great emphasis in providing a protected and secured
                security infrastructure that prevents unauthorised access or
                data theft and make best efforts in ensuring that our third
                party vendors employ the same high standards of security,
                reliability and dependability. This high standard of stable and
                reliable security provides our customers the peace of mind to
                bank securely and confidentially with alrajhi bank Malaysia via
                our various channels including internet banking.
              </p>
            </Col>
          </Row>
        </div>
      </div>

      <div className="spacer"></div>
      <div className="container">
        <Row>
          {clientCharterItems.map((item, index) => (
            <Col md={4} xs={12}>
              <div className="column-card d-flex flex-column">
                <img alt="security-img" src={item.image} />

                <div className="label">
                  <p>{item.label}</p>
                </div>
                <h1>{parse(item.title)}</h1>
                <p>{parse(item.description)}</p>
              </div>
            </Col>
          ))}
        </Row>

        <div className="column-card d-flex flex-column">
          <div className="label">
            <p>Queries and Complaints</p>
          </div>
          <h1>
            We strive to provide our customers with products and services that
            are best suited and beneficial for them
          </h1>
          <p>
            alrajhi bank Malaysia has established a dedicated and trained team
            to review and respond to queries and complaints promptly. Our
            dedicated team can be reached at:
            <br />
            <br />
            <a href="mailto:customersupport@alrajhibank.com.my">
              customersupport@alrajhibank.com.my
            </a>
            <br />
            Customer Care Hotline: +603 2332 6000
          </p>

          <div>
            <PrimaryButton
              text={"Customer Service Charter"}
              onClick={() => {
                handleOpenPdf(CUSTOMER_CLIENT_CHARTER);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ClientCharter;
